module.exports = __webpack_public_path__ + "static/media/D10.ae4b3024.png";